"use client";

import Terminal from "@/components/ui/Terminal";
import TerminalOutput from "@/components/ui/TerminalOutput";

interface TerminalWrapperProps {
  title?: string;
  className?: string;
  showHeader?: boolean;
  children: React.ReactNode;
}

export default function TerminalWrapper({ title, className, showHeader = true, children }: TerminalWrapperProps) {
  return (
    <Terminal title={title} className={className} showHeader={showHeader}>
      {children}
    </Terminal>
  );
}

export { TerminalOutput };